import React from 'react';


import Meta from '../../components/Helmet/Meta';
import SliderComponent from '../../components/Slider/Slider';
import Activities from '../../components/Activities/Activities';
import HeroSection from '../../components/HeroSection/HeroSection';
import Partners from '../../components/Partner/Partner';

import GenralMap from '../Map/GenralMap';

import Video from '../../components/Video/Video';

import Catalog from '../../components/Catalog/Catalog';

import Newsflash from '../../components/newsflash/Newsflash' ;


const HomeScreen = () => {

    return (
        <>
            <Meta />
            
            <HeroSection />


            <Video />

            <Catalog/>

            <Activities/>  

            <Partners/>

           

        </>
    )
}

export default HomeScreen;
